// This asset is loaded only by the FAYA alternate cart layout. No cross-brand redirects.
(()=>{
let pending=false;
const root=()=>document.querySelector('[data-faya-cart-section]');
// All shopping/close links return to the product page that opened this cart.
function productReturn(candidate) {
 if (!candidate) return null;
 try {
  const url=new URL(candidate,window.location.origin);
  if (url.origin!==window.location.origin || !/\/products\/[^/]+\/?$/.test(url.pathname)) return null;
  const view=url.searchParams.get('view');
  return url.pathname+(view?'?view='+encodeURIComponent(view):'');
 } catch (_) { return null; }
}
function syncReturnLinks() {
 const section=root();
 if (!section) return;
 let remembered=null;
 try { remembered=sessionStorage.getItem('faya:continue-shopping'); } catch (_) {}
 const target=productReturn(document.referrer)||productReturn(remembered);
 if (!target) return;
 try { sessionStorage.setItem('faya:continue-shopping',target); } catch (_) {}
 section.querySelectorAll('.faya-cart-back,.faya-cart-brand,.faya-cart-close,.faya-cart-shop,.faya-cart-continue,.faya-cart-review-link').forEach(link=>{
  const fragment=new URL(link.href,window.location.origin).hash;
  link.href=target+fragment;
 });
}
syncReturnLinks();
window.addEventListener('pageshow',syncReturnLinks);
async function change(key,quantity){
 if(pending)return;
 const section=root(),error=section.querySelector('[data-faya-cart-error]');
 if(!Number.isInteger(quantity)||quantity<0||quantity>99){error.textContent='Choose a quantity between 0 and 99. Zero removes the item.';error.hidden=false;return;}
 pending=true;error.hidden=true;section.setAttribute('aria-busy','true');
 const controls=[...section.querySelectorAll('button,input[data-faya-cart-quantity]')];controls.forEach(x=>x.disabled=true);
 try{
  const response=await fetch(section.dataset.changeUrl,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:key,quantity})});
  const data=await response.json();if(!response.ok)throw Error(data.description||data.message||'Could not update your cart. Please try again.');
  // Refresh server-rendered lines/keys after Shopify splits or merges discount rewards.
  location.reload();
 }catch(e){error.textContent=e.message||'Could not update your cart. Please try again.';error.hidden=false;pending=false;section.removeAttribute('aria-busy');controls.forEach(x=>x.disabled=false);}
}
document.addEventListener('click',event=>{
 const remove=event.target.closest('[data-faya-cart-remove]');if(remove){event.preventDefault();change(remove.dataset.key,0);return;}
 const button=event.target.closest('[data-faya-cart-delta]');if(button){const input=button.parentElement.querySelector('[data-faya-cart-quantity]');change(input.dataset.key,Math.max(0,Number(input.value)+Number(button.dataset.fayaCartDelta)));}
});
document.addEventListener('change',event=>{if(event.target.matches('[data-faya-cart-quantity]'))change(event.target.dataset.key,Number(event.target.value));});
document.addEventListener('keydown',event=>{if(event.key==='Enter'&&event.target.matches('[data-faya-cart-quantity]')){event.preventDefault();change(event.target.dataset.key,Number(event.target.value));}});
document.addEventListener('submit',event=>{if(pending&&event.target.matches('[data-faya-cart-form]'))event.preventDefault();});
})();
